import { IoIosHelpBuoy } from 'react-icons/io'
const HelpNotif = ({ handleHelp, helpText }) => {
  const spans = []
  helpText.forEach((help, index) => spans.push(<p className="ml-5">{help}</p>))
  return (
    <div className="notification is-size-7">
      <button className="delete" onClick={() => handleHelp(false)}></button>
      <div className="icon-text">
        <span className="icon has-text-link is-size-5">
          <IoIosHelpBuoy />
        </span>
      </div>
      {spans}
    </div>
  )
}

export default HelpNotif
